import React, { useState } from 'react';
import { TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';

const renderTextFieldCardNumber = ({ input, meta, disabled, ...custom }) => {
    const [error, setError] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const { t } = useTranslation();

    const validateCardNumber = value => {
        if (value.length === 16) {
            setError(false);
            setErrorMessage('');
        } else {
            setError(true);
            setErrorMessage(t('toDepositSorocoins.errorMessage'));
        }
    };

    const handleChange = e => {
        const value = e.target.value;
        const formattedValue = value.replace(/[^0-9]/g, '');
        input.onChange(formattedValue);
        validateCardNumber(formattedValue);
    };

    const handlePaste = e => {
        e.preventDefault();
        const pastedValue = e.clipboardData.getData('text').replace(/[^0-9]/g, '');
        input.onChange(pastedValue);
        validateCardNumber(pastedValue);
    };

    const handleKeyDown = e => {
        const value = input.value;
        const selectionLength =
            window.getSelection().toString().length || e.target.selectionEnd - e.target.selectionStart;
        if (value.length >= 16 && selectionLength === 0 && !['Backspace', 'Delete'].includes(e.key)) {
            e.preventDefault();
        }
    };

    return (
        <>
            <TextField
                {...input}
                {...custom}
                disabled={disabled}
                onChange={handleChange}
                onPaste={handlePaste}
                onKeyDown={handleKeyDown}
                error={error}
                helperText={error ? errorMessage : ''}
            />
        </>
    );
};

export default renderTextFieldCardNumber;
